export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: "「黑料每日」每天什么时候更新？",
    a: "我们通常在每天上午完成前一日的整理与归档，当天的新增内容会全天持续补充。你可以在归档中心按日期查看每一天的完整更新记录，也可以关注首页的「今日更新」板块。",
  },
  {
    q: "网站的内容主要覆盖哪些方向？",
    a: "目前分为全网热议、综艺现场、影视动态、舞台与现场、行业观察、社区趣闻六个方向。每个方向都有独立的汇总清单，方便按兴趣快速浏览。",
  },
  {
    q: "汇总清单和历史归档有什么区别？",
    a: "汇总清单按主题整理，帮助你看清一个话题的来龙去脉；历史归档按日期排列，帮助你回溯「某一天都发生了什么」。前者偏话题脉络，后者偏时间线，两者配合使用最方便。",
  },
  {
    q: "怎么快速找到之前看过的内容？",
    a: "有两种方式：一是使用顶部搜索框，按标题或标签检索；二是进入归档中心，按日期定位。如果记得大概主题，也可以先去对应的分类清单里翻一翻。",
  },
  {
    q: "内容会不会带有主观判断？",
    a: "我们尽量把事实和观点分开呈现。涉及具体主体时，多用「某节目」「某剧组」等泛化表述；如果信息尚未得到官方确认，我们会在正文里明确标注，不会当作既定事实处理。",
  },
  {
    q: "可以投稿或者反馈问题吗？",
    a: "可以。你可以在「关于我们」页面底部的联系表单里留言，写上你发现的线索或希望我们核实的内容。我们会安排时间统一查看，重要的反馈会优先跟进。",
  },
];